import Vue from 'vue';
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        defaultLayout: 'default-layout',
        currentLayout: 'default-layout',
    },
    mutations: {
        setCurrentLayout(state, currentLayout) {
            if (state.currentLayout != currentLayout) {
                state.currentLayout = currentLayout;
            }
        },
    },
    actions: {
        switchLayout({ state, commit, dispatch }, options) {
            if (options.layout) {
                return dispatch('getLayout', options.layout).catch(() => {
                    commit('setCurrentLayout', state.defaultLayout);
                });
            } else {
                commit('setCurrentLayout', state.defaultLayout);
            }
        },
        getLayout({ state, commit, rootState }, layout) {
            let path = '/layouts/';
            let layoutName = layout;
            let prefix = '';

            if (typeof layout == 'object') {
                path = layout.path;
                layoutName = layout.name;
                if (typeof layout.prefix === 'string' && layout.prefix.length > 0) {
                    prefix = layout.prefix;
                }
            }

            let componentName = `${prefix}${layoutName.replace('.', '-')}`;
            if (
                !Vue.options.components[componentName] &&
                !Vue.options.components[Vue.$language.getLanguage() + '_' + componentName]
            ) {
                let prefix = `${Vue.$language.getLanguage()}_`;
                if (rootState.PageContent.prerenderMode) {
                    prefix = `prerender_${prefix}`;
                }
                const requestEndpoint = `${path}${prefix}${layoutName}`;
                return axios
                    .get(requestEndpoint)
                    .then(r => r.data)
                    .then(results => {
                        Vue.component(Vue.$language.getLanguage() + '_' + componentName, {
                            template: `<div>${results}</div>`,
                        });
                        commit('setCurrentLayout', Vue.$language.getLanguage() + '_' + componentName);
                    })
                    .catch(() => {
                        commit('setCurrentLayout', state.currentLayout);
                    });
            } else if(Vue.options.components[componentName]) {
                commit('setCurrentLayout', componentName);
            } else {
                commit('setCurrentLayout', Vue.$language.getLanguage() + '_' + componentName);
            }
        },
    },
};
